// dependencies
import React from "react";

// components
import Text from "../../../../../../components/Text";
import { CardHeader } from "../../../../components/Card";

import TrendLineChart from "./eNPSTrendLineChart";

const ENPSTrendLineChart = () => {
	return (
		<>
			<CardHeader
				title={
					<span>
						<Text element="span" size="paragraph-2" weight="semi-bold">
							eNPS Trendline
						</Text>
					</span>
				}
				info="This chart displays the eNPS trend line."
			/>
			<TrendLineChart />
		</>
	);
};

export default ENPSTrendLineChart;
